import React, { useState, useEffect, useContext, useRef, useMemo } from 'react';
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";
import DatePicker from 'react-datepicker';
import { datePopperConfig } from "../Shared/datePopperConfig.js";
import MultiSelectField from "../Shared/MultiSelectField.js";
import AddItemCustomFields from "../Shared/AddItemCustomFields.js";
import AddCertificateAndRegistrations from "./AddCertificateAndRegistrations.js";


const AddItemPopup = ({ globalContext }) => {

    const urlParams = new URLSearchParams(window.location.search);

    const defaultCountryId = urlParams.get("filter[CountryId]") ?? null;
    const defaultProductId = urlParams.get("filter[ProductId]") ?? null;
    const defaultCertificateId = urlParams.get("filter[CertificateId]") ?? null;

    const [selectedOption, setSelectedOption] = useState("certificate-registrations");

    const [addProductId, setAddProductId] = useState(defaultProductId);
    const [addCountry, setAddCountry] = useState(defaultCountryId);
    const [addCertificate, setAddCertificate] = useState(defaultCertificateId);
    const [addIssued, setAddIssued] = useState(null);
    const [addRiskClass, setAddRiskClass] = useState(null);
    const [addRegistrationStatus, setAddRegistrationStatus] = useState(null);
    const [addSelling, setAddSelling] = useState(null);
    const [addAssigned, setAddAssigned] = useState(null);
    const [addPriority, setAddPriority] = useState(null);
    const [addExpiryDate, setAddExpiryDate] = useState(null);



    const [errorAddProductId, setErrorAddProductId] = useState("");
    const [errorAddProductName, setErrorAddProductName] = useState("");
    const [errorAddCertificate, setErrorAddCertificate] = useState(false);
    const [errorAddCountry, setErrorAddCountry] = useState(false);
    const [errorAddIssued, setErrorAddIssued] = useState(false);
    const [errorAddRiskClass, setErrorAddRiskClass] = useState(false);
    const [errorAddRegistrationStatus, setErrorAddRegistrationStatus] = useState(false);
    const [errorAddSelling, setErrorAddSelling] = useState(false);
    const [errorAddAssigned, setErrorAddAssigned] = useState(false);
    const [errorAddPriority, setErrorAddPriority] = useState(false);
    const [errorAddExpiryDate, setErrorAddExpiryDate] = useState(false);

    const [errorAddingItem, setErrorAddingItem] = useState(null);




    const [isAddingItem, setIsAddingItem] = useState(false);
    const [fieldsConfig, setFieldsConfig] = useState([]); // Facets
    const [formState, setFormState] = useState({});
    const [searchValues, setSearchValues] = useState({});
    const [activeDropdown, setActiveDropdown] = useState(null);


    const [countries, setCountries] = useState([]);

    const [field_DISTRIBUTORS, setField_DISTRIBUTORS] = useState({});
    const [fieldConfig_DISTRIBUTORS, setFieldConfig_DISTRIBUTORS] = useState([]);
    const [formState_DISTRIBUTORS, setFormState_DISTRIBUTORS] = useState({});

    const [field_IMPORTERS, setField_IMPORTERS] = useState({});
    const [fieldConfig_IMPORTERS, setFieldConfig_IMPORTERS] = useState([]);
    const [formState_IMPORTERS, setFormState_IMPORTERS] = useState({});


    const [field_REPRESENTATIVES, setField_REPRESENTATIVES] = useState({});
    const [fieldConfig_REPRESENTATIVES, setFieldConfig_REPRESENTATIVES] = useState([]);
    const [formState_REPRESENTATIVES, setFormState_REPRESENTATIVES] = useState({});


    const [certificatesLOV, setCertificatesLOV] = useState([]);
    const [products, setProducts] = useState([]);

    const dropdownRefs = useRef({});

    const AppContext = globalContext;





    // This method validates if the form field if filled, sets the error message to
    // true for that field and returns false meaning the field is not valid

    const validFormField = (field, errorFunc) => {
        if (field == "" || field == null) {
            errorFunc(true);
            return false;
        }
        errorFunc(false);
        return true;
    };


    function toBoolean(value) {
        return value === "true";
    }




    const addItem = () => {

        let isValidForm = true;

        setErrorAddCertificate(false);
        setErrorAddCountry(false);
        setErrorAddProductId(false);

        setErrorAddingItem(null);

        if (!validFormField(addCountry, setErrorAddCountry))
            isValidForm = false;
        if (!validFormField(addProductId, setErrorAddProductId))
            isValidForm = false;
        if (!validFormField(addRiskClass, setErrorAddRiskClass))
            isValidForm = false;
        if (!validFormField(addRegistrationStatus, setErrorAddRegistrationStatus))
            isValidForm = false;
        if (!validFormField(addSelling, setErrorAddSelling))
            isValidForm = false;
        if (!validFormField(addPriority, setErrorAddPriority))
            isValidForm = false;

        if (!isValidForm) {
            setErrorAddingItem("Some of the mandatory fields are empty");
            return false;
        }



        let newItem = {
            Id: 0,
            CertificateId: addCertificate != "" ? parseInt(addCertificate) : null,
            CountryId: addCountry,
            ProductId: addProductId,
            RiskClass: parseInt(addRiskClass),
            Status: parseInt(addRegistrationStatus),
            IssuedBy: addIssued,
            ExpiryDate: addExpiryDate,
            Selling: toBoolean(addSelling),
            AssignedTo: parseInt(addAssigned),
            Priority: parseInt(addPriority),
            ImportersIds: formState_IMPORTERS["importers"],
            CountryRepresentativesIds: formState_REPRESENTATIVES["representatives"],
            CountryDistributorsIds: formState_DISTRIBUTORS["distributors"],
            CustomFieldsAnswers: AppContext.newItemCustomFieldsAnswers,
        };



        setIsAddingItem(true);

        let dataUrl = AppContext.dataUrl;

        let requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(newItem)
        };




        fetch(dataUrl, requestOptions)
            .then(async (response) => {
                if (!response.ok) {

                    let message = await response.text();

                    if (response.status == 400)
                        throw new Error(message);

                    throw new Error("Unexpected error, refresh and try again");
                }

                return response.json();
            })
            .then((item) => {

                let result = [item, ...AppContext.data];

                AppContext.setData(result);
                AppContext.updateListTotalCount();
                AppContext.showAddItemPopup(false);

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
                setErrorAddingItem(error.message);
            })
            .finally(() => {
                setIsAddingItem(false);
            });


    }



    const loadOperators = (preserveSelection = false) => {

        let url = "/umbraco/api/ProductRegistrationsApi/OperatorsGroupedByRole";

        let requestOptions = {};

        return fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                // Importers

                let importers = { Alias: "importers", Name: "Importers", Items: [] };

                importers.Items = data.importers.map(item => ({ Text: item.Establishment, Value: item.EstablishmentId, Disabled: false, Group: null, Selected: false }));

                setField_IMPORTERS(importers);
                setFieldConfig_IMPORTERS([importers]);
                if (!preserveSelection)
                    setFormState_IMPORTERS({ importers: [] });

                // Representatives

                let representatives = { Alias: "representatives", Name: "Representatives", Items: [] };

                representatives.Items = data.representatives.map(item => ({ Text: item.Establishment, Value: item.EstablishmentId, Disabled: false, Group: null, Selected: false }));

                setField_REPRESENTATIVES(representatives);
                setFieldConfig_REPRESENTATIVES([representatives]);
                if (!preserveSelection)
                    setFormState_REPRESENTATIVES({ representatives: [] });


                // Distributors

                let distributors = { Alias: "distributors", Name: "Distributors", Items: [] };

                distributors.Items = data.distributors.map(item => ({ Text: item.Establishment, Value: item.EstablishmentId, Disabled: false, Group: null, Selected: false }));

                setField_DISTRIBUTORS(distributors);
                setFieldConfig_DISTRIBUTORS([distributors]);
                if (!preserveSelection)
                    setFormState_DISTRIBUTORS({ distributors: [] });


            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
            })
            .finally(() => {
            });

    }



    const loadCountries = () => {

        let url = "/umbraco/api/RIMSProducts/Countries";

        let requestOptions = {};

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                let countries = data.map(country => ({ id: country.CountryId, name: country.CountryName }));

                countries.sort((a, b) => a.name.localeCompare(b.name));

                let NA = { id: 0, name: "N/A" };

                countries = [NA, ...countries];

                setCountries(countries);

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
            })
            .finally(() => {
            });
    }


    
    const loadCertificates = () => {

        let countriesUrl = "/umbraco/api/RIMSRegistrations/GroupedCertificates/";

        let requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        fetch(countriesUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                if (result) {

                    // Remove None

                    result = result.filter(item => item.Value != "");

                    setCertificatesLOV(result);
                }

            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
            });

    }


    
    const loadProducts = () => {

        let countriesUrl = "/umbraco/api/RIMSRegistrations/FamiliesAndProducts/";

        let requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        fetch(countriesUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                if (result)
                    setProducts(result);

            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
            });

    }



    useEffect(() => {

        loadOperators();

        loadCountries();

        loadCertificates();

        loadProducts();

    }, []);



    const riskClassList = [
        { Id: "", Name: "Choose an option" },
        { Id: 0, Name: "I" },
        { Id: 1, Name: "Is" },
        { Id: 2, Name: "Im" },
        { Id: 3, Name: "II" },
        { Id: 4, Name: "IIa" },
        { Id: 5, Name: "IIb" },
        { Id: 6, Name: "III" },
        { Id: 7, Name: "IV" },
        { Id: 8, Name: "A" },
        { Id: 9, Name: "B" },
        { Id: 10, Name: "C" },
        { Id: 11, Name: "D" },
        { Id: 12, Name: "Unclassified" },
        { Id: 13, Name: "Other" },
    ];


    const registrationStatusList = [
        { Id: "", Name: "Choose an option" },
        { Id: 7, Name: "Pre-Market Assessment", className: "g-bg-blue" },
        { Id: 0, Name: "New Registration Ongoing", className: "g-bg-blue" },
        { Id: 6, Name: "Registration Not Required", className: "g-bg-gray-light-v1" },
        { Id: 1, Name: "Active", className: "g-bg-green" },
        { Id: 3, Name: "Active - Renewing", className: "g-bg-green" },
        { Id: 4, Name: "Active - Modification", className: "g-bg-green" },
        { Id: 5, Name: "Suspended", className: "g-bg-lightred" },
        { Id: 2, Name: "Expired", className: "g-bg-lightred" },
        { Id: 8, Name: "Discontinued", className: "g-bg-black" },
        { Id: 9, Name: "Not Registered", className: "g-bg-orange" },
    ];


    const yesNoList = [
        { Id: "", Name: "Choose an option" },
        { Id: true, Name: "Yes" },
        { Id: false, Name: "No" },
    ];


    const renewalPriorityList = [
        { Id: "", Name: "Choose an option" },
        { Id: 0, Name: "None" },
        { Id: 1, Name: "Low" },
        { Id: 2, Name: "Medium" },
        { Id: 3, Name: "High" },
    ];



    return (
        <div className="add-task-popup">
            <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ width: "50%" }}>
                    <h3>Add {AppContext.singleItemTitle}s</h3>
                </div>
                <div style={{ width: "50%", textAlign: "right" }}>
                    <button
                        className="close-button"
                        onClick={() => AppContext.showAddItemPopup(false)}
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>
            </div>




            <div
                style={{
                    display: "flex",
                    width: "100%",
                    flexDirection: "row",
                    marginBottom: "15px",
                    marginTop: "10px"
                }}>

                <div
                    style={{
                        cursor: "pointer",
                        paddingBottom: "3px",
                        paddingLeft: "15px",
                        paddingRight: "15px",
                        ...(selectedOption == "certificate-registrations"
                            ? { borderBottom: "2px solid #00abff" }
                            : { borderBottom: "2px solid #f0f0f0" })
                    }}
                    onClick={() => setSelectedOption("certificate-registrations")}
                >
                    <i className="fas fa-box-open g-mr-5"></i> Add Certificate with Registrations
                </div>

                <div
                    style={{
                        cursor: "pointer",
                        paddingBottom: "3px",
                        paddingLeft: "15px",
                        paddingRight: "15px",
                        ...(selectedOption == "single-registration"
                            ? { borderBottom: "2px solid #00abff" }
                            : { borderBottom: "2px solid #f0f0f0" })
                    }}
                    onClick={() => setSelectedOption("single-registration")}
                >
                    <i className="fas fa-box-open g-mr-5"></i> Add Single Registration
                </div>

                <div
                    style={{
                        cursor: "pointer",
                        paddingBottom: "3px",
                        paddingLeft: "15px",
                        paddingRight: "15px",
                        ...(selectedOption == "bulk-registrations"
                            ? { borderBottom: "2px solid #00abff" }
                            : { borderBottom: "2px solid #f0f0f0" })
                    }}
                    onClick={() => setSelectedOption("bulk-registrations")}
                >
                    <i className="fas fa-file-alt g-mr-5"></i> Add Bulk Registrations
                </div>

                <div style={{ flex: 1, borderBottom: "2px solid #f0f0f0" }}></div>

            </div>




            <div style={{ marginTop: "20px" }}>


                {selectedOption == "single-registration" ?
                    <div style={{ paddingTop: "10px", }}>


                        <div style={{display: "flex", flexDirection: "row"} }>

                            <div style={{flex: 1}}>


                                <SearchableCountrySelect
                                    label="Country *"
                                    value={addCountry}
                                    onChange={setAddCountry}
                                    countries={countries}
                                />

                                {errorAddCountry && (
                                    <span className="form-field-error-message">
                                        This field is necessary
                                    </span>
                                )}

                                <br />



                                <CertificatesDropdown
                                    label="Certificate"
                                    data={certificatesLOV}
                                    value={addCertificate}
                                    error={errorAddCertificate}
                                    onChange={(item) => {
                                        if(item)
                                            setAddCertificate(item.Value);
                                        else
                                            setAddCertificate(null);
                                    }}
                                />

                                {errorAddCertificate && (
                                    <span className="form-field-error-message">
                                        This field is necessary
                                    </span>
                                )}
                           
                                <br />



                                <ProductsDropdown
                                    label="Product *"
                                    data={products}
                                    value={addProductId}
                                    error={errorAddProductId}
                                    onChange={(product) => {
                                        if(product)
                                            setAddProductId(product.Id);
                                        else
                                            setAddProductId(null);
                                    }}
                                />

                                {errorAddProductId && (
                                    <span className="form-field-error-message">
                                        This field is necessary
                                    </span>
                                )}

                                <br />



                                <div style={{ width: "100%" }}>
                                    Registration issued by (Organization)
                                    <br />
                                    <input className={`form-field-text add-task-field-name ${errorAddIssued ? " form-field-error" : null}`}
                                        value={addIssued}
                                        onChange={(e) => setAddIssued(e.target.value)}
                                        style={{ width: "100%" }} type="text" placeholder="" />

                                    {errorAddIssued && (
                                        <span className="form-field-error-message">
                                            This field is necessary
                                        </span>
                                    )}

                                </div>

                                <br />



                                {/* Importers */}


                                <div style={{ width: "100%" }}>

                                    <MultiSelectField
                                        field={field_IMPORTERS}
                                        formState={formState_IMPORTERS}
                                        setFormState={setFormState_IMPORTERS}
                                        fieldsConfig={fieldConfig_IMPORTERS}
                                        searchValues={searchValues}
                                        setSearchValues={setSearchValues}
                                        activeDropdown={activeDropdown}
                                        setActiveDropdown={setActiveDropdown}
                                        dropdownRefs={dropdownRefs}
                                        noneIsAll={false}
                                        allowAddOperator={true}
                                        operatorRoleId={2}
                                        onRefreshOperators={() => loadOperators(true)}
                                    />

                                </div>

                                <br />



                                {/* Representative */}

                                <div style={{ width: "100%" }}>

                                    <MultiSelectField
                                        field={field_REPRESENTATIVES}
                                        formState={formState_REPRESENTATIVES}
                                        setFormState={setFormState_REPRESENTATIVES}
                                        fieldsConfig={fieldConfig_REPRESENTATIVES}
                                        searchValues={searchValues}
                                        setSearchValues={setSearchValues}
                                        activeDropdown={activeDropdown}
                                        setActiveDropdown={setActiveDropdown}
                                        dropdownRefs={dropdownRefs}
                                        noneIsAll={false}
                                        allowAddOperator={true}
                                        operatorRoleId={3}
                                        onRefreshOperators={() => loadOperators(true)}
                                    />

                                </div>

                                <br />




                                {/* Distributors */}

                                <div style={{ width: "100%" }}>

                                    <MultiSelectField
                                        field={field_DISTRIBUTORS}
                                        formState={formState_DISTRIBUTORS}
                                        setFormState={setFormState_DISTRIBUTORS}
                                        fieldsConfig={fieldConfig_DISTRIBUTORS}
                                        searchValues={searchValues}
                                        setSearchValues={setSearchValues}
                                        activeDropdown={activeDropdown}
                                        setActiveDropdown={setActiveDropdown}
                                        dropdownRefs={dropdownRefs}
                                        noneIsAll={false}
                                        allowAddOperator={true}
                                        operatorRoleId={4}
                                        onRefreshOperators={() => loadOperators(true)}
                                    />

                                </div>

                                <br />




                                <div style={{ width: "100%" }}>
                                    Risk Class *
                                    <br />

                                    <select
                                        className={`form-field-text add-task-field-name ${errorAddRiskClass ? "form-field-error" : ""
                                            }`}
                                        value={addRiskClass}
                                        onChange={(e) => setAddRiskClass(e.target.value)}
                                        style={{ width: "100%" }}
                                    >
                                        {riskClassList.map((item) => (
                                            <option key={item.Id} value={item.Id}>
                                                {item.Name}
                                            </option>
                                        ))}
                                    </select>

                                    {errorAddRiskClass && (
                                        <span className="form-field-error-message">
                                            This field is necessary
                                        </span>
                                    )}
                                </div>

                                <br />



                                <div style={{ width: "100%" }}>
                                    Registration Status *
                                    <br />

                                    <select
                                        className={`form-field-text add-task-field-name ${errorAddRegistrationStatus ? "form-field-error" : ""
                                            }`}
                                        value={addRegistrationStatus}
                                        onChange={(e) => setAddRegistrationStatus(e.target.value)}
                                        style={{ width: "100%" }}
                                    >

                                        {registrationStatusList.map((item) => (
                                            <option key={item.Id} value={item.Id}>
                                                {item.Name}
                                            </option>
                                        ))}
                                    </select>

                                    {errorAddRegistrationStatus && (
                                        <span className="form-field-error-message">
                                            This field is necessary
                                        </span>
                                    )}
                                </div>

                                <br />




                                <div style={{ width: "100%" }}>
                                    Selling *
                                    <br />

                                    <select
                                        className={`form-field-text add-task-field-name ${errorAddSelling ? "form-field-error" : ""
                                            }`}
                                        value={addSelling}
                                        onChange={(e) => setAddSelling(e.target.value.toString())}
                                        style={{ width: "100%" }}
                                    >

                                        {yesNoList.map((item) => (
                                            <option key={item.Id.toString()} value={item.Id.toString()}>
                                                {item.Name}
                                            </option>
                                        ))}
                                    </select>

                                    {errorAddSelling && (
                                        <span className="form-field-error-message">
                                            This field is necessary
                                        </span>
                                    )}
                                </div>

                                <br />


                                <div style={{ width: "100%" }}>
                                    Assigned User
                                    <br />

                                    <select
                                        className={`form-field-text add-task-field-name ${errorAddAssigned ? "form-field-error" : ""
                                            }`}
                                        value={addAssigned}
                                        onChange={(e) => setAddAssigned(e.target.value)}
                                        style={{ width: "100%" }}
                                    >
                                        <option value="">Select User</option>

                                        {AppContext.users.map((user) => (
                                            <option key={user.Id} value={user.Id}>
                                                {user.Name}
                                            </option>
                                        ))}
                                    </select>

                                    {errorAddAssigned && (
                                        <span className="form-field-error-message">
                                            This field is necessary
                                        </span>
                                    )}
                                </div>

                                <br />





                                <div style={{ width: "100%" }}>
                                    Renewal Priority *
                                    <br />

                                    <select
                                        className={`form-field-text add-task-field-name ${errorAddPriority ? "form-field-error" : ""
                                            }`}
                                        value={addPriority}
                                        onChange={(e) => setAddPriority(e.target.value)}
                                        style={{ width: "100%" }}
                                    >

                                        {renewalPriorityList.map((item) => (
                                            <option key={item.Id} value={item.Id}>
                                                {item.Name}
                                            </option>
                                        ))}
                                    </select>

                                    {errorAddPriority && (
                                        <span className="form-field-error-message">
                                            This field is necessary
                                        </span>
                                    )}
                                </div>

                                <br />

                                <div style={{ width: "100%" }}>
                                    Expiry Date
                                    <br />

                                    <input
                                        className={`form-field-text add-task-field-name ${errorAddExpiryDate ? "form-field-error" : ""
                                            }`}
                                        value={addExpiryDate}
                                        onChange={(e) => setAddExpiryDate(e.target.value)}
                                        style={{ width: "100%" }}
                                        type="date"
                                    />

                                    {errorAddExpiryDate && (
                                        <span className="form-field-error-message">
                                            This field is necessary
                                        </span>
                                    )}
                                </div>

                                <br />









                                {/* CUSTOM FIELDS */}
                                {AppContext.enableCustomFields ? 
                                    <AddItemCustomFields entityType={AppContext.entityTypeId} context={AppContext} />
                                : null}


                                <br />

                                {/* BUTTONS */}

                                <div className="action-button-bar">

                                    <div className="action-button-bar-left">
                                        <button
                                            className="action-button cancel-button"
                                            onClick={() => AppContext.showAddItemPopup(false)}
                                        >
                                            Close
                                        </button>
                                    </div>

                                    <div className="action-button-bar-center">

                                        {errorAddingItem ? <div style={{ color: "#ff5400" }}>Error: {errorAddingItem}</div> : null}

                                    </div>

                                    <div className="action-button-bar-right">
                                        {isAddingItem ? (
                                            <LoadingSpinnerImage />
                                        ) : (
                                            <button
                                                className="action-button save-button"
                                                onClick={addItem}
                                            >
                                                Add Registration
                                            </button>
                                        )}
                                    </div>
                                </div>


                            </div>




                        </div>

                    </div>

                    : null}


                {selectedOption == "bulk-registrations" ?
                    <div style={{ paddingTop: "10px", textAlign: "center", paddingBottom: "30px" }}>
                        <div style={{ fontSize: "11px", textAlign: "left" }}>
                            <p>Use this option to automatically upload registrations using our MedBoard template for bulk upload. If you wish to use this option, please contact us and we will guide you to fill the form and evaluate your needs/data.</p>

                            <p> Current Registrations Upload Template version: v1.6</p>
                        </div>
                        <BulkImportRegistrations AppContext={AppContext} />

                    </div>
                    : null}



                {selectedOption == "certificate-registrations" ? 
                
                    <div style={{ paddingTop: "10px", textAlign: "center", paddingBottom: "30px" }}>
                        <AddCertificateAndRegistrations globalContext={AppContext} defaultCountry={addCountry} />
                    </div>
                
                : null}


            </div>


        </div>
    );
};




const SearchableCountrySelect = ({
    label,
    value,
    onChange,
    countries
}) => {

    const [isOpen, setIsOpen] = useState(false);
    const [search, setSearch] = useState("");

    const selected = countries.find(c => c.id == value);

    const filtered = countries.filter(c =>
        c.name.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div style={{ width: "100%", position: "relative" }}>

            {label}
            <br />

            <div
                style={{
                    position: "relative",
                    width: "100%"
                }}
            >

                <input
                    type="text"
                    value={isOpen ? search : (selected?.name || "")}
                    placeholder="Search country..."
                    onFocus={() => {
                        setIsOpen(true);
                        setSearch("");
                    }}
                    onChange={(e) => {
                        setSearch(e.target.value);
                        setIsOpen(true);
                    }}
                    onBlur={() => {
                        setTimeout(() => setIsOpen(false), 150);
                    }}
                    style={{
                        width: "100%",
                        padding: "6px",
                        paddingRight: "32px",
                        border: "1px solid #ccc",
                        borderRadius: "4px"
                    }}
                />

                {(value || search) && (
                    <button
                        type="button"
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={() => {
                            onChange(null); // or ""
                            setSearch("");
                            setIsOpen(false);
                        }}
                        style={{
                            position: "absolute",
                            right: "8px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            border: "none",
                            background: "transparent",
                            cursor: "pointer",
                            fontSize: "16px",
                            color: "#888",
                            padding: 0,
                            lineHeight: 1
                        }}
                    >
                        ×
                    </button>
                )}

            </div>

            {isOpen && (
                <div
                    style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        maxHeight: "200px",
                        overflowY: "auto",
                        background: "#fff",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        zIndex: 1000
                    }}
                >
                    {filtered.length > 0 ? (
                        filtered.map(country => (
                            <div
                                key={country.id}
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={() => {
                                    onChange(country.id);
                                    setIsOpen(false);
                                    setSearch(country.name);
                                }}
                                style={{
                                    padding: "6px",
                                    cursor: "pointer"
                                }}
                            >
                                {country.name}
                            </div>
                        ))
                    ) : (
                        <div style={{ padding: "6px", color: "#888" }}>
                            No results
                        </div>
                    )}
                </div>
            )}

        </div>
    );
};



const BulkImportRegistrations = ({ AppContext }) => {
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const [isDragging, setIsDragging] = useState(false); 

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            setFile(e.target.files[0]);
            setMessage(null); 
        }
    };

    // --- Drag and Drop Handlers ---
    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setIsDragging(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);

        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            setFile(e.dataTransfer.files[0]);
            setMessage(null);
            e.dataTransfer.clearData();
        }
    };
    // ------------------------------

    const handleUpload = async () => {
        if (!file) {
            setMessage({ type: "error", text: "Please select a file first." });
            return;
        }

        setLoading(true);
        setMessage(null);

        const formData = new FormData();
        formData.append("file", file);

        try {
            const response = await fetch("/umbraco/api/RIMSRegistrations/BulkImportRegistrations", {
                method: "POST",
                body: formData,
            });

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(errorText || "Upload failed");
            }

            const result = await response.json().catch(() => null);

            setMessage({
                type: "success",
                text: result?.message || "File uploaded successfully.",
            });

            AppContext.loadData({ nextPage: false });

        } catch (err) {
            setMessage({
                type: "error",
                text: err.message || "Something went wrong.",
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            style={{
                maxWidth: "400px",
                margin: "0 auto",
                padding: "24px",
                border: "1px solid #e0e0e0",
                borderRadius: "12px",
                background: "#fff",
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1)"
            }}
        >

            <label
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "30px 20px",
                    border: "2px dashed",
                    borderColor: isDragging ? "#3498db" : "#d1d5db",
                    borderRadius: "8px",
                    cursor: "pointer",
                    backgroundColor: isDragging ? "#ebf5fb" : "#f9fafb",
                    transition: "all 0.2s ease"
                }}
                onMouseOver={(e) => { if (!isDragging) e.currentTarget.style.borderColor = "#3498db"; }}
                onMouseOut={(e) => { if (!isDragging) e.currentTarget.style.borderColor = "#d1d5db"; }}
            >
                <i className="fas fa-upload" style={{ fontSize: "24px", color: isDragging ? "#3498db" : "#9ca3af", marginBottom: "8px" }}></i>
                <span style={{ textAlign: "center" }}>
                    {file ? file.name : "Click to select a file or drag and drop"}
                </span>
                <input
                    type="file"
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                />
            </label>

            {/* Button */}
            <button
                onClick={handleUpload}
                disabled={loading || !file}
                type="submit"
                className="btn u-btn-blue g-font-size-13 g-pl-12 g-pr-12 g-pt-8 g-pb-8"
                style={{
                    borderRadius: "20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                    cursor: loading || !file ? "not-allowed" : "pointer",
                    opacity: loading || !file ? 0.6 : 1,
                    border: "none",
                    width: "100%",
                    transition: "background 0.2s"
                }}
            >
                <i className={loading ? "fas fa-spinner fa-spin" : "fas fa-arrow-up"}></i>
                {loading ? "Uploading..." : "Upload registrations from Template"}
            </button>

            {/* Message */}
            {message && (
                <div
                    style={{
                        padding: "10px",
                        borderRadius: "6px",
                        background: message.type === "error" ? "#ffe5e5" : "#e6ffed",
                        color: message.type === "error" ? "#b30000" : "#1a7f37",
                        fontSize: "0.9rem"
                    }}
                >
                    {message.text}
                </div>
            )}
        </div>
    );
};










/*
USAGE:

<ProductTreeSelector
    onSelectionChange={(selectedIds) => {
        console.log(selectedIds);
    }}
/>

API RESPONSE FORMAT:

{
    Families: [
        { Id: 1, Name: "fam1" },
    ],
    Products: [
        { Id: 100, Name: "Prod1", FamilyId: 1 },
    ],
}
*/

const ProductTreeSelector = ({ onSelectionChange }) => {
    const [families, setFamilies] = useState([]);
    const [products, setProducts] = useState([]);

    const [selectedProducts, setSelectedProducts] = useState([]);

    const [productsExpanded, setProductsExpanded] = useState(false);

    const [expandedFamilies, setExpandedFamilies] = useState({});

    const productsCheckboxRef = useRef(null);

    useEffect(() => {
        loadData();
    }, []);

    useEffect(() => {
        if (onSelectionChange) {
            onSelectionChange(selectedProducts);
        }
    }, [selectedProducts]);

    const loadData = async () => {
        try {
            const response = await fetch(
                "/umbraco/api/RIMSRegistrations/FamiliesAndProducts/"
            );

            const data = await response.json();

            setFamilies(data.Families || []);
            setProducts(data.Products || []);
        } catch (err) {
            console.error("Failed loading products tree", err);
        }
    };

    const groupedFamilies = useMemo(() => {
        return families.map((family) => ({
            ...family,
            Products: products.filter(
                (product) => product.FamilyId === family.Id
            ),
        }));
    }, [families, products]);

    // -----------------------------
    // Selection Helpers
    // -----------------------------

    const isProductSelected = (productId) => {
        return selectedProducts.includes(productId);
    };

    const isFamilyFullySelected = (family) => {
        if (!family.Products.length) return false;

        return family.Products.every((p) =>
            selectedProducts.includes(p.Id)
        );
    };

    const isFamilyPartiallySelected = (family) => {
        const selectedCount = family.Products.filter((p) =>
            selectedProducts.includes(p.Id)
        ).length;

        return (
            selectedCount > 0 &&
            selectedCount < family.Products.length
        );
    };

    const areAllProductsSelected = () => {
        if (!products.length) return false;

        return products.every((p) =>
            selectedProducts.includes(p.Id)
        );
    };

    const areSomeProductsSelected = () => {
        return selectedProducts.length > 0;
    };

    // -----------------------------
    // Product Selection
    // -----------------------------

    const toggleProduct = (productId) => {
        setSelectedProducts((prev) => {
            if (prev.includes(productId)) {
                return prev.filter((id) => id !== productId);
            }

            return [...prev, productId];
        });
    };

    // -----------------------------
    // Family Selection
    // -----------------------------

    const toggleFamily = (family) => {
        const familyProductIds = family.Products.map((p) => p.Id);

        const fullySelected = familyProductIds.every((id) =>
            selectedProducts.includes(id)
        );

        if (fullySelected) {
            setSelectedProducts((prev) =>
                prev.filter((id) => !familyProductIds.includes(id))
            );
        } else {
            setSelectedProducts((prev) => [
                ...new Set([...prev, ...familyProductIds]),
            ]);
        }
    };

    // -----------------------------
    // Global Selection
    // -----------------------------

    const toggleAllProducts = () => {
        if (areAllProductsSelected()) {
            setSelectedProducts([]);
        } else {
            setSelectedProducts(products.map((p) => p.Id));
        }
    };

    // -----------------------------
    // Indeterminate Checkbox States
    // -----------------------------

    useEffect(() => {
        if (productsCheckboxRef.current) {
            productsCheckboxRef.current.indeterminate =
                areSomeProductsSelected() &&
                !areAllProductsSelected();
        }
    }, [selectedProducts]);

    // -----------------------------
    // Expand / Collapse
    // -----------------------------

    const toggleFamilyExpand = (familyId) => {
        setExpandedFamilies((prev) => ({
            ...prev,
            [familyId]: !prev[familyId],
        }));
    };

    return (
        <div style={{ width: "100%" }}>
            {/* ROOT */}
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    fontWeight: "600",
                }}
            >
                {/* CARET */}
                <span
                    style={{
                        cursor: "pointer",
                        width: "16px",
                        display: "inline-block",
                    }}
                    onClick={() =>
                        setProductsExpanded(!productsExpanded)
                    }
                >
                    {productsExpanded ? "▼" : "▶"}
                </span>

                {/* CHECKBOX */}
                <input
                    ref={productsCheckboxRef}
                    type="checkbox"
                    checked={areAllProductsSelected()}
                    onChange={toggleAllProducts}
                />

                {/* ICON */}
                <span>📦</span>

                {/* TITLE */}
                <span>Products</span>
            </div>

            {/* FAMILIES */}
            {productsExpanded && (
                <div style={{ marginLeft: "24px", marginTop: "8px" }}>
                    {groupedFamilies.map((family) => {
                        const familyCheckboxRef =
                            React.createRef();

                        setTimeout(() => {
                            if (familyCheckboxRef.current) {
                                familyCheckboxRef.current.indeterminate =
                                    isFamilyPartiallySelected(
                                        family
                                    );
                            }
                        }, 0);

                        return (
                            <div
                                key={family.Id}
                                style={{ marginBottom: "8px" }}
                            >
                                {/* FAMILY ROW */}
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                    }}
                                >
                                    {/* CARET */}
                                    <span
                                        style={{
                                            cursor: "pointer",
                                            width: "16px",
                                            display:
                                                "inline-block",
                                        }}
                                        onClick={() =>
                                            toggleFamilyExpand(
                                                family.Id
                                            )
                                        }
                                    >
                                        {expandedFamilies[
                                            family.Id
                                        ]
                                            ? "▼"
                                            : "▶"}
                                    </span>

                                    {/* CHECKBOX */}
                                    <input
                                        ref={familyCheckboxRef}
                                        type="checkbox"
                                        checked={isFamilyFullySelected(
                                            family
                                        )}
                                        onChange={() =>
                                            toggleFamily(family)
                                        }
                                    />

                                    {/* ICON */}
                                    <span>📁</span>

                                    {/* NAME */}
                                    <span>{family.Name}</span>
                                </div>

                                {/* PRODUCTS */}
                                {expandedFamilies[family.Id] && (
                                    <div
                                        style={{
                                            marginLeft: "32px",
                                            marginTop: "6px",
                                        }}
                                    >
                                        {family.Products.map(
                                            (product) => (
                                                <div
                                                    key={
                                                        product.Id
                                                    }
                                                    style={{
                                                        display:
                                                            "flex",
                                                        alignItems:
                                                            "center",
                                                        gap: "8px",
                                                        marginBottom:
                                                            "4px",
                                                    }}
                                                >
                                                    {/* SPACER */}
                                                    <span
                                                        style={{
                                                            width:
                                                                "16px",
                                                        }}
                                                    />

                                                    {/* CHECKBOX */}
                                                    <input
                                                        type="checkbox"
                                                        checked={isProductSelected(
                                                            product.Id
                                                        )}
                                                        onChange={() =>
                                                            toggleProduct(
                                                                product.Id
                                                            )
                                                        }
                                                    />

                                                    {/* ICON */}
                                                    <span>📄</span>

                                                    {/* NAME */}
                                                    <span>
                                                        {product.SKUCode}&nbsp;&nbsp;•&nbsp;&nbsp;{product.Name}
                                                    </span>
                                                </div>
                                            )
                                        )}
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};



const CertificatesDropdown = ({
    label = "",
    data = [],
    value = "",
    onChange = () => { },
    placeholder = "Select certificate",
    enableSearch = true,
    error = false,
    width = "100%"
}) => {

    const [search, setSearch] = useState("");
    const [isOpen, setIsOpen] = useState(false);

    // ================= FILTER =================
    const filteredData = useMemo(() => {

        if (!enableSearch)
            return data;

        return data.filter(item =>
            (item?.Text || "")
                .toLowerCase()
                .includes(search.toLowerCase())
        );

    }, [data, search, enableSearch]);

    // ================= GROUP =================
    const groupedData = useMemo(() => {

        const grouped = filteredData.reduce((acc, item) => {

            const groupName = item?.Group?.Name || "Other";

            if (!acc[groupName])
                acc[groupName] = [];

            acc[groupName].push(item);

            return acc;

        }, {});

        // SORT GROUPS + CERTIFICATES
        return Object.fromEntries(

            Object.entries(grouped)

                // SORT GROUPS
                .sort(([groupA], [groupB]) =>
                    groupA.localeCompare(groupB)
                )

                // SORT CERTIFICATES
                .map(([groupName, items]) => [

                    groupName,

                    items.sort((a, b) =>
                        (a.Text || "")
                            .localeCompare(b.Text || "")
                    )

                ])

        );

    }, [filteredData]);

    // ================= SELECTED ITEM =================
    const selectedItem = data.find(
        item => item.Value == value
    );

    // ================= RENDER =================
    return (

        <div
            style={{
                width,
                position: "relative"
            }}
        >

            {label}
            <br />

            <div
                style={{
                    position: "relative",
                    width: "100%"
                }}
            >

                <input
                    type="text"
                    value={
                        isOpen
                            ? search
                            : (selectedItem?.Text || "")
                    }
                    placeholder={placeholder}
                    className={`form-field-text ${error ? "form-field-error" : ""}`}
                    style={{
                        width: "100%",
                        paddingRight: "32px"
                    }}
                    onFocus={() => {
                        setIsOpen(true);
                        setSearch("");
                    }}
                    onChange={(e) => {
                        setSearch(e.target.value);
                        setIsOpen(true);
                    }}
                    onBlur={() => {
                        setTimeout(() => {
                            setIsOpen(false);
                        }, 150);
                    }}
                />

                {(value || search) && (
                    <button
                        type="button"
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={() => {
                            onChange(null); // or ""
                            setSearch("");
                            setIsOpen(false);
                        }}
                        style={{
                            position: "absolute",
                            right: "8px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            border: "none",
                            background: "transparent",
                            cursor: "pointer",
                            fontSize: "16px",
                            color: "#888",
                            padding: 0,
                            lineHeight: 1
                        }}
                    >
                        ×
                    </button>
                )}

            </div>

            {isOpen && (

                <div
                    style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        maxHeight: "260px",
                        overflowY: "auto",
                        background: "#fff",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        zIndex: 1000
                    }}
                >

                    {Object.keys(groupedData).length > 0 ? (

                        Object.entries(groupedData).map(
                            ([groupName, items]) => (

                                <div key={groupName}>

                                    {/* GROUP TITLE */}
                                    <div
                                        style={{
                                            padding: "8px 10px",
                                            fontWeight: "bold",
                                            background: "#f5f5f5",
                                            borderBottom: "1px solid #eee",
                                            fontSize: "12px",
                                            color: "#666"
                                        }}
                                    >
                                        {groupName}
                                    </div>

                                    {/* ITEMS */}
                                    {items.map(item => (

                                        <div
                                            key={item.Value}
                                            onMouseDown={(e) =>
                                                e.preventDefault()
                                            }
                                            onClick={() => {

                                                if (item.Disabled)
                                                    return;

                                                onChange(item);

                                                setSearch(item.Text);

                                                setIsOpen(false);

                                            }}
                                            style={{
                                                padding: "8px 10px",
                                                cursor: item.Disabled
                                                    ? "not-allowed"
                                                    : "pointer",
                                                opacity: item.Disabled
                                                    ? 0.5
                                                    : 1,
                                                background:
                                                    value == item.Value
                                                        ? "#f0f7ff"
                                                        : "#fff"
                                            }}
                                        >

                                            {item.Text}

                                        </div>

                                    ))}

                                </div>

                            )
                        )

                    ) : (

                        <div
                            style={{
                                padding: "8px 10px",
                                color: "#888"
                            }}
                        >
                            No results
                        </div>

                    )}

                </div>

            )}

        </div>

    );

};



const ProductsDropdown = ({
    label = "",
    data = {
        Families: [],
        Products: []
    },
    value = "",
    onChange = () => { },
    placeholder = "Select product",
    enableSearch = true,
    error = false,
    width = "100%"
}) => {
    
    const [search, setSearch] = useState("");
    const [isOpen, setIsOpen] = useState(false);

    // ================= CREATE FAMILY MAP =================
    const familyMap = useMemo(() => {

        const map = {};

        (data?.Families || []).forEach(family => {

            map[family.Id] = family.Name;

        });

        return map;

    }, [data]);

    // ================= FILTER PRODUCTS =================
    const filteredProducts = useMemo(() => {

        let products = data?.Products || [];

        if (!enableSearch)
            return products;

        return products.filter(product => {

            const text = `
                ${product?.Name || ""}
                ${product?.SKUCode || ""}
                ${familyMap[product?.FamilyId] || ""}
            `.toLowerCase();

            return text.includes(search.toLowerCase());

        });

    }, [data, search, enableSearch, familyMap]);

    // ================= GROUP + SORT =================
    const groupedProducts = useMemo(() => {

        const grouped = filteredProducts.reduce((acc, product) => {

            const familyName =
                familyMap[product?.FamilyId] || "Other";

            if (!acc[familyName])
                acc[familyName] = [];

            acc[familyName].push(product);

            return acc;

        }, {});

        // SORT FAMILIES + PRODUCTS
        return Object.fromEntries(

            Object.entries(grouped)

                // SORT FAMILIES
                .sort(([familyA], [familyB]) =>
                    familyA.localeCompare(familyB)
                )

                // SORT PRODUCTS
                .map(([familyName, items]) => [

                    familyName,

                    items.sort((a, b) =>
                        (a.Name || "")
                            .localeCompare(b.Name || "")
                    )

                ])

        );

    }, [filteredProducts, familyMap]);

    // ================= SELECTED PRODUCT =================
    const selectedProduct = useMemo(() => {
        return (data?.Products || []).find(
            product => String(product.Id) === String(value)
        );
    }, [data, value]);



    useEffect(() => {
        if (selectedProduct) {
            setSearch(`${selectedProduct.Name} (${selectedProduct.SKUCode})`);
        } else {
            setSearch("");
        }
    }, [selectedProduct]);




    // ================= RENDER =================
    return (

        <div
            style={{
                width,
                position: "relative"
            }}
        >
            {label}
            <br />
            <div
                style={{
                    position: "relative",
                    width: "100%"
                }}
>
                <input
                    type="text"
                    value={
                        isOpen
                            ? search
                            : selectedProduct
                                ? `${selectedProduct.Name} (${selectedProduct.SKUCode})`
                                : ""
                    }
                    placeholder={placeholder}
                    className={`form-field-text ${error ? "form-field-error" : ""}`}
                    style={{
                        width: "100%",
                        paddingRight: "32px"
                    }}
                    onFocus={() => {
                        setIsOpen(true);
                        setSearch("");
                    }}
                    onChange={(e) => {
                        setSearch(e.target.value);
                        setIsOpen(true);
                    }}
                    onBlur={() => {
                        setTimeout(() => {
                            setIsOpen(false);
                        }, 150);
                    }}
                />

                {(value || search) && (
                    <button
                        type="button"
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={() => {
                            onChange(null);
                            setSearch("");
                            setIsOpen(false);
                        }}
                        style={{
                            position: "absolute",
                            right: "8px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            border: "none",
                            background: "transparent",
                            cursor: "pointer",
                            fontSize: "16px",
                            color: "#888",
                            padding: 0,
                            lineHeight: 1
                        }}
                    >
                        ×
                    </button>
                )}
            </div>

            {isOpen && (

                <div
                    style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        maxHeight: "300px",
                        overflowY: "auto",
                        background: "#fff",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        zIndex: 1000
                    }}
                >

                    {Object.keys(groupedProducts).length > 0 ? (

                        Object.entries(groupedProducts).map(
                            ([familyName, items]) => (

                                <div key={familyName}>

                                    {/* FAMILY TITLE */}
                                    <div
                                        style={{
                                            padding: "8px 10px",
                                            fontWeight: "bold",
                                            background: "#f5f5f5",
                                            borderBottom: "1px solid #eee",
                                            fontSize: "12px",
                                            color: "#666"
                                        }}
                                    >
                                        {familyName}
                                    </div>

                                    {/* PRODUCTS */}
                                    {items.map(product => (

                                        <div
                                            key={product.Id}
                                            onMouseDown={(e) =>
                                                e.preventDefault()
                                            }
                                            onClick={() => {

                                                onChange(product);

                                                setSearch(
                                                    `${product.SKUCode}&nbsp;&nbsp;•&nbsp;&nbsp;${product.Name}`
                                                );

                                                setIsOpen(false);

                                            }}
                                            style={{
                                                padding: "10px",
                                                cursor: "pointer",
                                                background:
                                                    value == product.Id
                                                        ? "#f0f7ff"
                                                        : "#fff",
                                                borderBottom: "1px solid #f5f5f5"
                                            }}
                                        >

                                            <div
                                                style={{
                                                    fontSize: "14px",
                                                    fontWeight: 500
                                                }}
                                            >
                                                {product.Name}
                                            </div>

                                            <div
                                                style={{
                                                    fontSize: "12px",
                                                    color: "#666",
                                                    marginTop: "2px"
                                                }}
                                            >
                                                {product.SKUCode}
                                            </div>

                                        </div>

                                    ))}

                                </div>

                            )
                        )

                    ) : (

                        <div
                            style={{
                                padding: "10px",
                                color: "#888"
                            }}
                        >
                            No results
                        </div>

                    )}

                </div>

            )}

        </div>

    );

};






export default AddItemPopup;